
import React from 'react';

// import PropTypes from 'prop-types'

import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ButtonGroup,
    Stack,
    Chip,
    Button,
    Menu,
    Typography,
    Badge
} from '@mui/material';
// import { useAuthAccess } from '../../hooks/useAuthAccess'

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { supportLanguages, enableTranslation } from '../../configs/languageConfigs';

import { CommonIcons, icons } from './CommonIcons';

import { useTranslations } from '../../hooks/useTranslations';

export default function CommonTranslation({
    showSelection = false
}) {

    // const { authData } = useAuthAccess();

    // console.log('supportLanguages', supportLanguages)

    const { getCurrentLanguageId, getCurrentLanguageName, changeLanguage } = useTranslations({ ns: [] })

    const RenderSelector = () => {
        return (
            <PopupState
                variant="popover"
                popupId="dataGridToolbar"
            >
                {(popupState) => (
                    <>
                        <ButtonGroup variant="outline">
                            {
                                showSelection === true &&
                                <Stack direction="row" spacing={1}>
                                    <Chip
                                        label={getCurrentLanguageName()}
                                        variant='outlined'
                                    />
                                </Stack>
                            }
                            <Button
                                {...bindTrigger(popupState)}
                                size="large"
                                variant='text'
                                sx={{
                                    // backgroundColor: '#000',
                                    // borderRadius: 30,
                                }}
                            // variant="outlined"
                            // aria-controls={open ? 'split-button-menu' : undefined}
                            // aria-expanded={open ? 'true' : undefined}
                            // aria-label="select merge strategy"
                            // aria-haspopup="menu"
                            // onClick={handleToggle}
                            >
                                {/* <MoreVertIcon /> */}
                                <CommonIcons
                                    name={icons.translation}
                                    sx={{
                                        color: '#000'
                                    }}
                                />
                            </Button>
                        </ButtonGroup>

                        <Menu
                            {...bindMenu(popupState)}
                            sx={{
                                p: 0,
                                m: 0
                            }}
                        >

                            {
                                supportLanguages.map((item, index) => {
                                    return (
                                        <MenuItem
                                            key={index}
                                            sx={{
                                                // m: 1,
                                                m: 0
                                            }}
                                            onClick={() => {
                                                popupState.close();

                                                // change language
                                                changeLanguage(item?.id)

                                            }}
                                            selected={
                                                getCurrentLanguageId() === item?.id
                                            }
                                        >
                                            <Typography
                                                sx={{
                                                    // textTransform: 'lowercase'
                                                }}
                                            >
                                                {item?.name}
                                            </Typography>
                                        </MenuItem>
                                    )
                                })
                            }

                        </Menu>

                    </>
                )}
            </PopupState>
        )
    }

    return (
        (enableTranslation === false) ?
            <></>
            :
            <RenderSelector />
    )
}

